import { PrimaryTextColor, boldFont, getRelativeFontSize, mediumFont, heading, primaryBlueColor, primaryLightGray, primaryWhiteColor, regularFont, subHeading } from "../../../../utils/styles";

const ShowAllStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  pageHeading: {
    ...heading,
  },
  content: {
    padding: "0 70px",
  },
  checkBoxWarapper: {
    diplay: "flex",
    marginTop: "10px",
  },
  pageSubHeading: {
    ...subHeading,
  },
  statusHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...mediumFont,
  },
  showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
  },
  menuPart:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
  },

  topPart:{
    display:"flex",
    justifyContent:"end"
  },
  selectBox:{
    // width:"10%",
    display:"flex",
    gap:"10px",
    // padding:"1px 10px",
    width:"100%",
    justifyContent:"end",
  
    "& .MuiInputBase-input":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-inputFocused":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-root":{
      maxHeight:"100%",
      // background:primaryGrayBg,
    },
   
    datePicker:{
      border:"1px solid #e0e0e0",
      padding:"5px 48px",
      borderRadius:"4px",
      fontSize:"14px",
      cursor:"pointer",
      fontWeight:"600",
       height:"36px"
  },
  },

  filterBold:{
    fontSize:"12px",
    // fontWeight:600,
    display:"flex",
    alignItems:"center"

  },

  datePickerBox:{
    margin:"0",
    width:"40%",

    "& .MuiFormLabel-root":{
      fontSize: getRelativeFontSize(0),
      top:"-3px",
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      padding:"12px 10px",
    },
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    width:"25%",

    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
    flexDirection: "column",
    "& button": {
      color: primaryBlueColor,
      height: "10px",
      fontSize: getRelativeFontSize(-2),
    },
  },

  buttonWrapperDialog: {
    width: "350px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    "& button": {
      color: primaryBlueColor,
      fontSize: getRelativeFontSize(-2),
      "&:nth-child(2)": {
        color: "#ffffff",
      },
    },
  },

  rowtext: {
    ...mediumFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-3),
    display: "flex",
    alignItems: "center",
    gap:"8px",
    textWrap:"auto",
    "& .MuiSvgIcon-root":{
fontSize:"13px"
    }
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },

  fullName: {
    ...regularFont,
    fontcolor: "#0C0E2E",
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
  },

  emp_type_btn: {
    background: "#18CB8A",
    width: "60px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: getRelativeFontSize(-4),
    textTransform: "capitalize",
    ...regularFont,
    borderRadius: "4px",
    color: "#ffffff",
  },

  activeBtn: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
    },
  },

  deActive: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
      background: "red",
      borderColor: "red",
      "&:hover": {
        background: "red",
        borderColor: "red",
      },
    },
  },

  popOverContent: {
    position: "relative",
    top: "20px",
  },

  popOverBtn: {
    position: "absolute",
  },

  Info_btn: {
    height: "18px",
    width: "fit-content",
    padding: "0 10px",
    ...regularFont,
    borderRadius: "4px",
    background: "#F4BE5E",
    fontSize: getRelativeFontSize(-4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5px",
    color: "#ffffff",
    textTransform: "capitalize",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    "& button": {
      width: "fit-content",
      height:"32px",
      "&:hover": {
        background: "none",
      },
    },
  },
  customgridStyle:{
    "& .css-yrdy0g-MuiDataGrid-columnHeaderRow":{
      display: "flex",
    justifyContent: "space-between",
    },

  },
  tableGridPart:{
    "& .MuiDataGrid-withBorderColor":{
      border: "none",
      // borderRight: "none",
    },
    "& .MuiDataGrid-main": {
      borderTop: "1px solid #EEEFF2",
    },
    "& .MuiDataGrid-columnHeaders":{
      borderBottom: "1px solid #EEEFF2",
      fontSize:"14px",
      ...boldFont
    },
  },
  tableCustom:{
    color:"red"
  },
  dataGridContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  columnHeaders: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#fff",
  },
  virtualScroller: {
    overflowY: "auto", 
    maxHeight: "calc(100vh - 334px)",
  },
};

export default ShowAllStyles;
